import { PendoContext } from "@/context/pendoContext"
import { useContext } from "react"

export interface PendoGlobal {
  /**
   * @param options The init options containing the individual user id
   */
  initialize: (options: unknown) => void;

  clearSession: () => void;

  track: (eventName: string, properties?: Record<string, unknown>) => void;

  trackAgent: (eventType: string, metadata: Record<string, unknown>) => void;
}

export function usePendo() {
  const context = useContext(PendoContext)
  if (!context) {
    throw new Error("usePendo must be used within a PendoProvider")
  }
  return context
}
